import type { GAEvent as GAEventRaw } from 'common/utils/analytics';

export const BRIDGE_EVENT_TYPE = 'event' as const;

export interface IEventBridgeEvent<E> {
	category: string;
	originalEvent: E;
	timestamp: string;
}

export interface IEventBridgeAdapter<OriginalEvent, FormattedEvent = OriginalEvent> {
	formatEvent: (
		e: OriginalEvent
	) => IEventBridgeEvent<FormattedEvent extends OriginalEvent ? OriginalEvent : FormattedEvent>;
}

// Type for custom events
export type CustomEvent = {
	type: string; // e.g.: navigation, performance.*
	details: Record<string, unknown>; // e.g.:original event details
};

// Type for API events
export type ApiEvent = {
	type: string; // e.g.: api.send_answer
	details: Record<string, unknown>; // e.g.:original event details
};

export type GAEvent = {
	type: string; // e.g.: ga.send_answer
	details: GAEventRaw; // e.g.:original event details
};

// Union type for all events that can flow through EventEmitter
export type BridgeEvent = {
	type: typeof BRIDGE_EVENT_TYPE;
	data: (GAEvent | ApiEvent | CustomEvent) &
		Pick<IEventBridgeEvent<GAEvent | ApiEvent | CustomEvent>, 'timestamp' | 'category'>;
};
